import React from 'react'
import { Input, Radio, Tooltip } from 'antd';
import { CloseCircleTwoTone } from '@ant-design/icons';

const { TextArea } = Input;

export default function MultipleChoiceItem(props) {
   const isAnswerMode = props.mode === "answer";
   const isReadOnly = props.mode.includes("assign") || props.mode.includes("view");
   const isChecked = props.correct === "1";

   const handleRemoveOption = (idx) => {
      props.parentCallback("remove", "", idx);
   }

   const handleChange = (value) => {
      props.parentCallback("update", value, props.id);
   }

   const handleCheckChange = (event) => {
      props.parentCallback("update-check-radio", event.target.checked, props.id);
   }

   const handleOptionSelect = () => {
      if (!isAnswerMode || isChecked) return;
      props.parentCallback("update-check-radio", true, props.id);
   }

   const handleOptionKeyDown = (event) => {
      if (event.key === "Enter" || event.key === " ") {
         event.preventDefault();
         handleOptionSelect();
      }
   }

   return (
      <>
         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '7px' }}>
            <Radio
               name={props.cardid}
               checked={isChecked}
               onChange={handleCheckChange}
               disabled={isReadOnly}
            >
               {
                  (props.mode.includes("view") || isAnswerMode) &&
                  String.fromCharCode(65 + props.id)
               }
            </Radio>
            {
               isAnswerMode || isReadOnly
                  ? (
                     <div
                        role={isAnswerMode ? "button" : undefined}
                        tabIndex={isAnswerMode ? 0 : undefined}
                        onClick={isAnswerMode ? handleOptionSelect : undefined}
                        onKeyDown={isAnswerMode ? handleOptionKeyDown : undefined}
                        style={{
                           borderRadius: 7,
                           width: "100%",
                           marginRight: '7px',
                           fontSize: '14px',
                           padding: '6px 7px',
                           minHeight: 30,
                           border: '1px solid #d9d9d9',
                           backgroundColor: isAnswerMode ? '#ffffff' : '#f5f5f5',
                           cursor: isAnswerMode ? 'pointer' : 'default',
                           textAlign: 'left'
                        }}
                     >
                        {props.value}
                     </div>
                  )
                  : (
                     <TextArea
                        autoSize={{
                           minRows: 1,
                           maxRows: 2,
                        }}
                        id={props.id}
                        name={props.id}
                        defaultValue={props.value}
                        onBlur={(e) => handleChange(e.target.value)}
                        allowClear
                        style={{ borderRadius: 7, width: "100%", marginRight: '7px', fontSize: '14px' }}
                     />
                  )
            }
            {
               isAnswerMode || isReadOnly
                  ? <></>
                  :
                  <Tooltip placement="right" title='Remove answer key'>
                     <CloseCircleTwoTone twoToneColor="red" style={{ cursor: "pointer", fontSize: "16px" }} onClick={() => handleRemoveOption(props.id)} />
                  </Tooltip>
            }
         </div>
      </>
   )
}
